import {IAirport} from "../../../store/reducers/fleetReducer/fleetReducerTypes";

export const calculateArrivalDate = (airportFrom: IAirport, airportTo: IAirport, departureDate: Date, durationInMinutes: number) => {
  return new Date(departureDate.getTime() + durationInMinutes * 60000);
}

/**
 * Calculates arrival date from departure date and flight duration
 * This is a universal function used across the system for consistent arrival time calculation
 * 
 * @param departureDate - The departure date/time
 * @param flightDurationMinutes - Flight duration in minutes
 * @param technicalStopDurationMinutes - Optional technical stop duration in minutes (default: 0)
 * @returns Arrival date or null if calculation cannot be performed
 */
export const calculateArrivalDateFromDuration = (
  departureDate: Date | null,
  flightDurationMinutes: number | undefined | null,
  technicalStopDurationMinutes?: number | undefined | null
): Date | null => {
  if (!departureDate || flightDurationMinutes === undefined || flightDurationMinutes === null) {
    return null;
  }
  
  const totalDurationMinutes = flightDurationMinutes + (technicalStopDurationMinutes ?? 0);
  
  if (totalDurationMinutes <= 0) {
    return null;
  }
  
  return new Date(departureDate.getTime() + totalDurationMinutes * 60000);
}

export const getRecentUTCMondayWithWeekOffset = (offset: number = 0, boundaryDate: boolean = false): Date => {
  const dateNow = new Date();
  return new Date(
    dateNow.getUTCFullYear(),
    dateNow.getUTCMonth(),
    dateNow.getUTCDate() + (7 * offset) - dateNow.getUTCDay() + 1,
    0,
    0,
    0,
    boundaryDate ? -1 : 0);
}


export const getUTCDateWithDayOffset = (offset: number = 0, boundaryDate: boolean = false): Date => {
  const dateNow = new Date();
  return new Date(dateNow.getUTCFullYear(), dateNow.getUTCMonth(), dateNow.getUTCDate() + offset, 0, 0, 0, boundaryDate ? -1 : 0);
}